interface salesdetails  {
    text: string,
    rowspan: string,
    colspan: string,
    text2?: string,
    rowspan2?: string,
    colspan2?: string,
    text3?: string,
    rowspan3?: string,
    colspan3?: string,
    row: number
}

let list = [
    {
        text: "一、一般计税方法计税",
        rowspan: "7",
        colspan: "1",
        text2: "全部征税项目",
        rowspan2: "5",
        colspan2: "1",
        text3: "13%税率的货物及加工修理修配劳务",
        rowspan3: "1",
        colspan3: "1",
        row: 1
    },
    {
        text: "13%税率的服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 2
    },
    {
        text: "9%税率的货物及加工修理修配劳务",
        rowspan: "1",
        colspan: "1",
        row: 3
    },
    {
        text: "9%税率的服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 4
    },
    {
        text: "6%税率",
        rowspan: "1",
        colspan: "1",
        row: 5
    },
    {
        text: "其中：即征即退项目",
        rowspan: "2",
        colspan: "1",
        text2: "即征即退货物及加工修理修配劳务",
        rowspan2: "1",
        colspan2: "1",
        row: 6
    },
    {
        text: "即征即退服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 7
    },
    {
        text: "二、简易计税方法计税",
        rowspan: "11",
        colspan: "1",
        text2: "全部征税项目",
        rowspan2: "9",
        colspan2: "1",
        text3: "6%征收率",
        rowspan3: "1",
        colspan3: "1",
        row: 8
    },
    {        
        text: "5%征收率的货物及加工修理修配劳务",
        rowspan: "1",
        colspan: "1",
        row: 9
    },
    {
        text: "5%征收率的服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 10
    },
    {
        text: "4%征收率",
        rowspan: "1",
        colspan: "1",
        row: 11
    },
    {
        text: "3%征收率的货物及加工修理修配劳务",
        rowspan: "1",
        colspan: "1",
        row: 12
    },
    {
        text: "3%征收率的服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 13
    },
    {
        text: "预征率   %",
        rowspan: "1",
        colspan: "1",
        row: 14
    },
    {
        text: "预征率   %",
        rowspan: "1",
        colspan: "1",
        row: 15
    },
    {
        text: "预征率   %",
        rowspan: "1",
        colspan: "1",
        row: 16
    },
    {
        text: "其中：即征即退项目",
        rowspan: "2",
        colspan: "1",
        text2: "即征即退货物及加工修理修配劳务",
        rowspan2: "1",
        colspan2: "1",
        row: 17
    },
    {
        text: "即征即退服务、不动产和无形资产",
        rowspan: "1",
        colspan: "1",
        row: 18
    },
    {
        text: "三、免抵退税",
        rowspan: "2",
        colspan: "1",
        text2: "货物及加工修理修配劳务",
        rowspan2: "1",
        colspan2: "2",
        row: 19
    },
    {
        text: "服务、不动产和无形资产",
        rowspan: "1",
        colspan: "2",
        row: 20
    },
    {
        text: "四、免税",
        rowspan: "2",
        colspan: "1",
        text2: "货物及加工修理修配劳务",
        rowspan2: "1",
        colspan2: "2",
        row: 21
    },
    {
        text: "服务、不动产和无形资产",
        rowspan: "2",
        colspan: "2",
        row: 22
    }
];

let salesdetails = {
    list: list,
}
export default salesdetails
